import React from 'react';
import { useHistory } from 'react-router-dom';
import {
  mob_Painthon,
  mob_Conan,
  mob_nextButton,
  buttonImg,
} from '../../../constants/iconImageConstant';
import { Header } from '../../Header/Header';
import { Footer } from '../../appFooter/Footer';


export function MobEventPage() {
  const history = useHistory();

  const handleNavigate = (path: string) => {
    history.push(path);
  };

  return (
    <div>
      <Header />
      <main role="main" className="container">
        {/* Paintathon Section */}
        <div className="col-md-12 mt-5 mb-3 zoom position-relative">
          <img src={mob_Painthon} alt="paintathon" className="img-fluid" width="100%" loading="lazy" />
          <div className="video-wrapper" style={{ background: '#50584b', width: '55%', position: 'absolute', top: '45%', left: '8%', borderRadius: '5px', padding: '5px' }}>
            <div className="embed-responsive embed-responsive-16by9">
              <div className="video-container">
                <video width="100%" height="auto" autoPlay muted>
                <source src="https://assets.etvbalbharat.com/video/PAINTATHON_PROMO._website.mp4" type="video/mp4" />
                  Your browser does not support the video tag.
                </video>
              </div>
            </div>
          </div>
          <div className="nxpgbtn-pain">
            <button onClick={() => handleNavigate('/mobpaintathon')} className="btn-link" style={{ border: 'none', background: 'none', padding: 0 }}>
              <img src={mob_nextButton} alt="paint-btn" width="100" loading="lazy" />
            </button>
          </div>
        </div>

        {/* Conan Section */}
        <div className="col-md-12 zoom position-relative">
          <img src={mob_Conan} alt="conan" className="img-fluid" width="100%" loading="lazy" />
          <div className="video-wrapper" style={{ background: '#50584b', width: '55%', position: 'absolute', top: '46%', left: '8%', borderRadius: '5px', padding: '5px' }}>
            <div className="embed-responsive embed-responsive-16by9">
              <div className="video-container">
                <video width="100%" height="auto" autoPlay muted>
                <source src="https://assets.etvbalbharat.com/video/CONAN.mp4" type="video/mp4" />
                  Your browser does not support the video tag.
                </video>
              </div>
            </div>
          </div>
          <div className="nxpgbtn-conan">
            <button onClick={() => handleNavigate('/mob_canon_winner_year')} className="btn-link" style={{ border: 'none', background: 'none', padding: 0 }}>
              <img src={buttonImg} alt="conan-btn" width="85" loading="lazy"/>
            </button>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}


















































































// old code without video source comment 14/03/2025

// import React from 'react';
// import { useHistory } from 'react-router-dom';
// import { mob_Painthon, mob_Conan,
// mob_nextButton,buttonImg} from '../../../constants/iconImageConstant';
// import { Header } from '../../Header/Header';
// import { Footer } from '../../appFooter/Footer';

// export function MobEventPage() {
//   const history = useHistory();

//   const handleNavigate = (path: string) => {
//     history.push(path);
//   };

//   return (
//     <div>
//       <Header />
//       <main role="main" className="container">
//         <div className="col-md-12 mt-5 mb-3 zoom">
//           <div className="nxpgbtn-pain">
//             <a onClick={() => handleNavigate('/mobpaintathon')}>
//               <img src={mob_nextButton} alt="paint-btn" width="100" className="clickable-image" />
//             </a>
//           </div>
//           <img
//             src={mob_Painthon}
//             alt="paintathon"
//             className="img-fluid"
//             width="100%"
//             onClick={() => handleNavigate('/mobpaintathon')}
//           />
//         </div>
//         <div className="col-md-12 zoom">
//           <div className="nxpgbtn-conan">
//             <a onClick={() => handleNavigate('/mob_canon_winner_year')}>
//               <img src={buttonImg} alt="conan-btn" width="85" className="clickable-image" />
//             </a>
//           </div>
//           <a onClick={() => handleNavigate('/mob_canon_winner_year')}>
//             <img
//               src={mob_Conan}
//               alt="conan"
//               className="img-fluid clickable-image"
//               width="100%"
//             />
//           </a>
//         </div>
//       </main>
//       <Footer />
//     </div>
//   );
// }
















